import React from "react";
import { FieldRenderProps } from "react-final-form";

import CardList, { CardListExternalProps } from "components/Input/CardList";

import withFieldControl from "../FieldControl";

type DictionaryItem = {
  value: any;
  label: string;
};

type Props = {
  required?: boolean;
  name: string;
  multi?: boolean;
} & CardListExternalProps;

class CardListFieldControl extends React.Component<
  FieldRenderProps<any> & Props
> {
  onChange = (item: DictionaryItem) => {
    const {
      input: { onChange },
    } = this.props;

    const event: any = { target: { value: item?.value } };
    onChange(event);
  };

  onMultiChange = (items: DictionaryItem[] = []) => {
    const {
      input: { onChange },
    } = this.props;

    const value = items.map(item => item.value);
    const event: any = { target: { value } };
    onChange(event);
  };

  render() {
    const { input, validate, multi, ...props } = this.props;
    return (
      <CardList
        input={input}
        onChange={!multi ? this.onChange : this.onMultiChange}
        multi={multi}
        {...props}
      />
    );
  }
}

export default withFieldControl(CardListFieldControl);
